(function () {
	'use strict';

	/**
	 * @ngdoc directive
	 * @name mx.SolutionBuilderAgent:mxPanelTitle
	 * @module mx.SolutionBuilderAgent
	 * @restrict 'A'
	 * @description Panel Title. In used in Dialog template from Server Side.
	 */

	angular.module('mx.SolutionBuilderAgent').directive('mxPanelTitle', function mxPanelTitleDirective() {
		return {
			restrict: 'A',
			link: function (scope, element) {
				element.append('<span class="mx-aria-only">.</span>');
			},
		};
	});
})();
